// Today's Print Queue (Emin NJ Depot) strings — EN + TR.
//
// T1.11 Shipping-V1. Skeleton page mounted under Supply Shell (per T1.10
// adaptation — dedicated /warehouse shell deferred to Wave-16 Madde 15).
// V1 empty state placeholder; Phase 3+ wires actual queue data + functional
// date filter.
//
// Capability gate: ship.shipment.scan (warehouse_operator + admin).
// Mehmet / Hakan / Aybars SO2/SO3 supply personas → Forbidden message.
//
// Anchors: feedback_a32_capability_resolution_v1
//        + feedback_shipping_v1_mini_batch_2_guard_closure_2026-06-05
//        + reference_persona_rename_aybars_to_emin_2026_06_04

import type { LocalizedDict } from '../index'

type TodaysPrintQueueStrings = {
  title: string
  subtitle: string
  dateFilterPlaceholder: string
  emptyState: string
  loading: string
  errorState: string
  forbidden: string
  columnShipment: string
  columnOrder: string
  columnPackages: string
  columnWeight: string
  columnCreated: string
  columnActions: string
  actionPrintA4: string
  printNoWorkOrderTitle: string
  printNoWorkOrderDesc: string
  printMockTitle: string
  printMockDesc: string
  actionPin: string
  actionUnpin: string
  actionAddPiece: string
  multiPieceTooltip: string
  pinnedBadge: string
  weightUnit: string
}

export const todaysPrintQueueI18n: LocalizedDict<TodaysPrintQueueStrings> = {
  en: {
    title: "Today's Print Queue",
    subtitle: 'Shipments awaiting label print + packaging dispatch',
    dateFilterPlaceholder: 'Date filter (Phase 3+)',
    emptyState: 'No shipments queued for print right now.',
    loading: 'Loading print queue...',
    errorState: 'Failed to load print queue.',
    forbidden: 'You do not have access to this page.',
    columnShipment: 'Shipment',
    columnOrder: 'Order',
    columnPackages: 'Pkgs',
    columnWeight: 'Weight',
    columnCreated: 'Created',
    columnActions: 'Actions',
    actionPrintA4: 'Print A4 Combined',
    printNoWorkOrderTitle: 'No work order yet',
    printNoWorkOrderDesc:
      'This shipment has no linked work order to print a packing slip from.',
    printMockTitle: 'Packing slip (simulation)',
    printMockDesc:
      'The A4 packing slip downloads here once the real engine is connected.',
    actionPin: 'Pin',
    actionUnpin: 'Unpin',
    actionAddPiece: '+ Piece',
    multiPieceTooltip: 'Add another package for this order',
    pinnedBadge: 'Pinned',
    weightUnit: 'oz',
  },
  tr: {
    title: 'Bugünün Yazdırma Kuyruğu',
    subtitle: 'Etiket yazdırma + paketleme sevkiyatı bekleyen gönderiler',
    dateFilterPlaceholder: 'Tarih filtresi (Faz 3+)',
    emptyState: 'Şu an basılacak etiket yok.',
    loading: 'Yazdırma kuyruğu yükleniyor...',
    errorState: 'Yazdırma kuyruğu yüklenemedi.',
    forbidden: 'Bu sayfaya erişim yetkiniz yok.',
    columnShipment: 'Gönderi',
    columnOrder: 'Sipariş',
    columnPackages: 'Koli',
    columnWeight: 'Ağırlık',
    columnCreated: 'Oluşturma',
    columnActions: 'İşlemler',
    actionPrintA4: 'A4 Birleşik Yazdır',
    printNoWorkOrderTitle: 'Henüz iş emri yok',
    printNoWorkOrderDesc:
      'Bu gönderiye bağlı bir iş emri bulunmadığı için paket fişi yazdırılamadı.',
    printMockTitle: 'Paket fişi (simülasyon)',
    printMockDesc:
      'Gerçek motor bağlandığında A4 paket fişi buradan indirilecek.',
    actionPin: 'Sabitle',
    actionUnpin: 'Sabiti Kaldır',
    actionAddPiece: '+ Koli',
    multiPieceTooltip: 'Bu sipariş için ek koli ekle',
    pinnedBadge: 'Sabit',
    weightUnit: 'oz',
  },
}
